const nationalities = [
  {
    value: 'AF',
    text:  'Afeganistão',
  },
  {
    value: 'ZA',
    text:  'África do Sul',
  },
  {
    value: 'AL',
    text:  'Albânia',
  },
  {
    value: 'DE',
    text:  'Alemanha',
  },
  {
    value: 'AD',
    text:  'Andorra',
  },
  {
    value: 'AO',
    text:  'Angola',
  },
  {
    value: 'AI',
    text:  'Anguilla',
  },
  {
    value: 'AQ',
    text:  'Antárctida',
  },
  {
    value: 'AG',
    text:  'Antígua e Barbuda',
  },
  {
    value: 'SA',
    text:  'Arábia Saudita',
  },
  {
    value: 'DZ',
    text:  'Argélia',
  },
  {
    value: 'AR',
    text:  'Argentina',
  },
  {
    value: 'AM',
    text:  'Arménia',
  },
  {
    value: 'AW',
    text:  'Aruba',
  },
  {
    value: 'AU',
    text:  'Austrália',
  },
  {
    value: 'AT',
    text:  'Áustria',
  },
  {
    value: 'AZ',
    text:  'Azerbaijão',
  },
  {
    value: 'BS',
    text:  'Bahamas',
  },
  {
    value: 'BD',
    text:  'Bangladesh',
  },
  {
    value: 'BB',
    text:  'Barbados',
  },
  {
    value: 'BH',
    text:  'Barein',
  },
  {
    value: 'BE',
    text:  'Bélgica',
  },
  {
    value: 'BZ',
    text:  'Belize',
  },
  {
    value: 'BJ',
    text:  'Benim',
  },
  {
    value: 'BM',
    text:  'Bermuda',
  },
  {
    value: 'BY',
    text:  'Bielorússia',
  },
  {
    value: 'BO',
    text:  'Bolívia, Estado Plurinacional da',
  },
  {
    value: 'BQ',
    text:  'Bonaire, Santo Eustáquio e Saba',
  },
  {
    value: 'BA',
    text:  'Bósnia-Herzegóvina',
  },
  {
    value: 'BW',
    text:  'Botsuana',
  },
  {
    value:    'BR',
    text:     'Brasil',
    selected: true,
  },
  {
    value: 'BN',
    text:  'Brunei',
  },
  {
    value: 'BG',
    text:  'Bulgária',
  },
  {
    value: 'BF',
    text:  'Burkina Faso',
  },
  {
    value: 'BI',
    text:  'Burundi',
  },
  {
    value: 'BT',
    text:  'Butão',
  },
  {
    value: 'CV',
    text:  'Cabo Verde',
  },
  {
    value: 'CM',
    text:  'Camarões',
  },
  {
    value: 'KH',
    text:  'Cambodja',
  },
  {
    value: 'CA',
    text:  'Canadá',
  },
  {
    value: 'KZ',
    text:  'Cazaquistão',
  },
  {
    value: 'TD',
    text:  'Chade',
  },
  {
    value: 'CL',
    text:  'Chile',
  },
  {
    value: 'CN',
    text:  'China',
  },
  {
    value: 'CY',
    text:  'Chipre',
  },
  {
    value: 'CO',
    text:  'Colômbia',
  },
  {
    value: 'KM',
    text:  'Comoros',
  },
  {
    value: 'CG',
    text:  'Congo',
  },
  {
    value: 'CD',
    text:  'Congo, República Democrática do',
  },
  {
    value: 'KP',
    text:  'Coreia, República Popular Democrática de',
  },
  {
    value: 'KR',
    text:  'Coreia, República da',
  },
  {
    value: 'CR',
    text:  'Costa Rica',
  },
  {
    value: 'CI',
    text:  'Costa do Marfim',
  },
  {
    value: 'HR',
    text:  'Croácia',
  },
  {
    value: 'CU',
    text:  'Cuba',
  },
  {
    value: 'CW',
    text:  'Curação',
  },
  {
    value: 'DK',
    text:  'Dinamarca',
  },
  {
    value: 'DJ',
    text:  'Djibouti',
  },
  {
    value: 'DM',
    text:  'Dominica',
  },
  {
    value: 'EG',
    text:  'Egipto',
  },
  {
    value: 'SV',
    text:  'El Salvador',
  },
  {
    value: 'AE',
    text:  'Emirados Árabes Unidos',
  },
  {
    value: 'EC',
    text:  'Equador',
  },
  {
    value: 'ER',
    text:  'Eritreia',
  },
  {
    value: 'SK',
    text:  'Eslováquia',
  },
  {
    value: 'SI',
    text:  'Eslovénia',
  },
  {
    value: 'ES',
    text:  'Espanha',
  },
  {
    value: 'US',
    text:  'Estados Unidos',
  },
  {
    value: 'EE',
    text:  'Estónia',
  },
  {
    value: 'ET',
    text:  'Etiópia',
  },
  {
    value: 'RU',
    text:  'Federação Russa',
  },
  {
    value: 'FJ',
    text:  'Fiji',
  },
  {
    value: 'PH',
    text:  'Filipinas',
  },
  {
    value: 'FI',
    text:  'Finlândia',
  },
  {
    value: 'FR',
    text:  'França',
  },
  {
    value: 'GA',
    text:  'Gabão',
  },
  {
    value: 'GM',
    text:  'Gâmbia',
  },
  {
    value: 'GH',
    text:  'Gana',
  },
  {
    value: 'GS',
    text:  'Geórgia do Sul e Ilhas Sandwich do Sul',
  },
  {
    value: 'GE',
    text:  'Geórgia',
  },
  {
    value: 'GI',
    text:  'Gibraltar',
  },
  {
    value: 'GD',
    text:  'Granada',
  },
  {
    value: 'GR',
    text:  'Grécia',
  },
  {
    value: 'GL',
    text:  'Gronelândia',
  },
  {
    value: 'GP',
    text:  'Guadalupe',
  },
  {
    value: 'GU',
    text:  'Guam',
  },
  {
    value: 'GT',
    text:  'Guatemala',
  },
  {
    value: 'GG',
    text:  'Guernsey',
  },
  {
    value: 'GF',
    text:  'Guiana Francesa',
  },
  {
    value: 'GY',
    text:  'Guiana',
  },
  {
    value: 'GQ',
    text:  'Guiné Equatorial',
  },
  {
    value: 'GN',
    text:  'Guiné',
  },
  {
    value: 'GW',
    text:  'Guiné-Bissáu',
  },
  {
    value: 'HT',
    text:  'Haiti',
  },
  {
    value: 'HN',
    text:  'Honduras',
  },
  {
    value: 'HK',
    text:  'Hong Kong',
  },
  {
    value: 'HU',
    text:  'Hungria',
  },
  {
    value: 'BV',
    text:  'Ilha Bouvet',
  },
  {
    value: 'HM',
    text:  'Ilha Heard e Ilhas McDonald',
  },
  {
    value: 'CX',
    text:  'Ilha Natal',
  },
  {
    value: 'NF',
    text:  'Ilha Norfolk',
  },
  {
    value: 'RE',
    text:  'Ilha Reunião',
  },
  {
    value: 'IM',
    text:  'Ilha de Man',
  },
  {
    value: 'AX',
    text:  'Ilhas Åland',
  },
  {
    value: 'KY',
    text:  'Ilhas Caimão',
  },
  {
    value: 'CC',
    text:  'Ilhas Cocos',
  },
  {
    value: 'CK',
    text:  'Ilhas Cook',
  },
  {
    value: 'FK',
    text:  'Ilhas Falkland (Malvinas)',
  },
  {
    value: 'FO',
    text:  'Ilhas Feroé',
  },
  {
    value: 'MP',
    text:  'Ilhas Marianas do Norte',
  },
  {
    value: 'MH',
    text:  'Ilhas Marshall',
  },
  {
    value: 'UM',
    text:  'Ilhas Menores Exteriores dos Estados Unidos',
  },
  {
    value: 'SB',
    text:  'Ilhas Salomão',
  },
  {
    value: 'TC',
    text:  'Ilhas Turks e Caicos',
  },
  {
    value: 'VG',
    text:  'Ilhas Virgens, Britânicas',
  },
  {
    value: 'VI',
    text:  'Ilhas Virgens, Estados Unidos',
  },
  {
    value: 'IN',
    text:  'Índia',
  },
  {
    value: 'ID',
    text:  'Indonésia',
  },
  {
    value: 'IR',
    text:  'Irão, República Islâmica do',
  },
  {
    value: 'IQ',
    text:  'Iraque',
  },
  {
    value: 'IE',
    text:  'Irlanda',
  },
  {
    value: 'IS',
    text:  'Islândia',
  },
  {
    value: 'IL',
    text:  'Israel',
  },
  {
    value: 'IT',
    text:  'Itália',
  },
  {
    value: 'JM',
    text:  'Jamaica',
  },
  {
    value: 'JP',
    text:  'Japão',
  },
  {
    value: 'JE',
    text:  'Jersey',
  },
  {
    value: 'JO',
    text:  'Jordânia',
  },
  {
    value: 'KI',
    text:  'Kiribati',
  },
  {
    value: 'KW',
    text:  'Kuwait',
  },
  {
    value: 'LS',
    text:  'Lesoto',
  },
  {
    value: 'LV',
    text:  'Letónia',
  },
  {
    value: 'LB',
    text:  'Líbano',
  },
  {
    value: 'LR',
    text:  'Libéria',
  },
  {
    value: 'LY',
    text:  'Líbia',
  },
  {
    value: 'LI',
    text:  'Liechtenstein',
  },
  {
    value: 'LT',
    text:  'Lituânia',
  },
  {
    value: 'LU',
    text:  'Luxemburgo',
  },
  {
    value: 'MO',
    text:  'Macau',
  },
  {
    value: 'MK',
    text:  'Macedónia, República',
  },
  {
    value: 'MG',
    text:  'Madagáscar',
  },
  {
    value: 'MY',
    text:  'Malásia',
  },
  {
    value: 'MW',
    text:  'Malawi',
  },
  {
    value: 'MV',
    text:  'Maldivas',
  },
  {
    value: 'ML',
    text:  'Mali',
  },
  {
    value: 'MT',
    text:  'Malta',
  },
  {
    value: 'MA',
    text:  'Marrocos',
  },
  {
    value: 'MQ',
    text:  'Martinica',
  },
  {
    value: 'MU',
    text:  'Maurícias',
  },
  {
    value: 'MR',
    text:  'Mauritânia',
  },
  {
    value: 'YT',
    text:  'Mayotte',
  },
  {
    value: 'MX',
    text:  'México',
  },
  {
    value: 'FM',
    text:  'Micronesia, Estados Federados da',
  },
  {
    value: 'MZ',
    text:  'Moçambique',
  },
  {
    value: 'MD',
    text:  'Moldávia, República da',
  },
  {
    value: 'MC',
    text:  'Mónaco',
  },
  {
    value: 'MN',
    text:  'Mongólia',
  },
  {
    value: 'ME',
    text:  'Montenegro',
  },
  {
    value: 'MS',
    text:  'Montserrat',
  },
  {
    value: 'MM',
    text:  'Myanmar',
  },
  {
    value: 'NA',
    text:  'Namíbia',
  },
  {
    value: 'NR',
    text:  'Nauru',
  },
  {
    value: 'NP',
    text:  'Nepal',
  },
  {
    value: 'AN',
    text:  'Netherlands Antilles',
  },
  {
    value: 'NI',
    text:  'Nicarágua',
  },
  {
    value: 'NE',
    text:  'Níger',
  },
  {
    value: 'NG',
    text:  'Nigéria',
  },
  {
    value: 'NU',
    text:  'Niue',
  },
  {
    value: 'NO',
    text:  'Noruega',
  },
  {
    value: 'NC',
    text:  'Nova Caledónia',
  },
  {
    value: 'NZ',
    text:  'Nova Zelândia',
  },
  {
    value: 'OM',
    text:  'Oman',
  },
  {
    value: 'NL',
    text:  'Países Baixos',
  },
  {
    value: 'PW',
    text:  'Palau',
  },
  {
    value: 'PS',
    text:  'Palestina, Autoridade da',
  },
  {
    value: 'PA',
    text:  'Panamá',
  },
  {
    value: 'PG',
    text:  'Papua Nova Guiné',
  },
  {
    value: 'PK',
    text:  'Paquistão',
  },
  {
    value: 'PY',
    text:  'Paraguai',
  },
  {
    value: 'PE',
    text:  'Peru',
  },
  {
    value: 'PN',
    text:  'Pitcairn',
  },
  {
    value: 'PF',
    text:  'Polinésia Francesa',
  },
  {
    value: 'PL',
    text:  'Polónia',
  },
  {
    value: 'PR',
    text:  'Porto Rico',
  },
  {
    value: 'PT',
    text:  'Portugal',
  },
  {
    value: 'QA',
    text:  'Quatar',
  },
  {
    value: 'KE',
    text:  'Quénia',
  },
  {
    value: 'KG',
    text:  'Quirgistão',
  },
  {
    value: 'GB',
    text:  'Reino Unido',
  },
  {
    value: 'SY',
    text:  'República Árabe Síria',
  },
  {
    value: 'CF',
    text:  'República Centro-Africana',
  },
  {
    value: 'CZ',
    text:  'República Checa',
  },
  {
    value: 'LA',
    text:  'República Democrática Popular do Laos',
  },
  {
    value: 'DO',
    text:  'República Dominicana',
  },
  {
    value: 'SS',
    text:  'República do Sudão',
  },
  {
    value: 'RO',
    text:  'Roménia',
  },
  {
    value: 'RW',
    text:  'Ruanda',
  },
  {
    value: 'EH',
    text:  'Sahara Ocidental',
  },
  {
    value: 'BL',
    text:  'Saint Barthélemy',
  },
  {
    value: 'KN',
    text:  'Saint Kitts e Nevis',
  },
  {
    value: 'PM',
    text:  'Saint Pierre e Miquelon',
  },
  {
    value: 'AS',
    text:  'Samoa Americana',
  },
  {
    value: 'WS',
    text:  'Samoa',
  },
  {
    value: 'SM',
    text:  'San Marino',
  },
  {
    value: 'SH',
    text:  'Santa Helema, Ascenção e Tristão da Cunha',
  },
  {
    value: 'LC',
    text:  'Santa Lúcia',
  },
  {
    value: 'VA',
    text:  'Santa Sé (Estado Cidade do Vaticano)',
  },
  {
    value: 'MF',
    text:  'São Martin (Território Francês)',
  },
  {
    value: 'SX',
    text:  'São Martinho (Países Baixos)',
  },
  {
    value: 'ST',
    text:  'São Tomé e Príncipe',
  },
  {
    value: 'VC',
    text:  'São Vicente e Grenadinas',
  },
  {
    value: 'SN',
    text:  'Senegal',
  },
  {
    value: 'SL',
    text:  'Serra Leoa',
  },
  {
    value: 'RS',
    text:  'Sérvia',
  },
  {
    value: 'SC',
    text:  'Seychelles',
  },
  {
    value: 'SG',
    text:  'Singapura',
  },
  {
    value: 'SO',
    text:  'Somália',
  },
  {
    value: 'LK',
    text:  'Sri Lanka',
  },
  {
    value: 'SZ',
    text:  'Suazilândia',
  },
  {
    value: 'SD',
    text:  'Sudão',
  },
  {
    value: 'SE',
    text:  'Suécia',
  },
  {
    value: 'CH',
    text:  'Suíça',
  },
  {
    value: 'SR',
    text:  'Suriname',
  },
  {
    value: 'SJ',
    text:  'Svalbard e Jan Mayen',
  },
  {
    value: 'TJ',
    text:  'Tadjaquistão',
  },
  {
    value: 'TH',
    text:  'Tailândia',
  },
  {
    value: 'TW',
    text:  'Taiwan',
  },
  {
    value: 'TZ',
    text:  'Tanzânia, República Unida da',
  },
  {
    value: 'IO',
    text:  'Território Britânico do Oceano Índico',
  },
  {
    value: 'TF',
    text:  'Territórios Franceses do Sul',
  },
  {
    value: 'TL',
    text:  'Timor-Leste',
  },
  {
    value: 'TG',
    text:  'Togo',
  },
  {
    value: 'TK',
    text:  'Tokelau',
  },
  {
    value: 'TO',
    text:  'Tonga',
  },
  {
    value: 'TT',
    text:  'Trinidade e Tobago',
  },
  {
    value: 'TN',
    text:  'Tunísia',
  },
  {
    value: 'TM',
    text:  'Turcomenistão',
  },
  {
    value: 'TR',
    text:  'Turquia',
  },
  {
    value: 'TV',
    text:  'Tuvalu',
  },
  {
    value: 'UA',
    text:  'Ucrânia',
  },
  {
    value: 'UG',
    text:  'Uganda',
  },
  {
    value: 'UY',
    text:  'Uruguai',
  },
  {
    value: 'UZ',
    text:  'Uzbequistão',
  },
  {
    value: 'VU',
    text:  'Vanuatu',
  },
  {
    value: 'VE',
    text:  'Venezuela, República Bolivariana da',
  },
  {
    value: 'VN',
    text:  'Vietname',
  },
  {
    value: 'WF',
    text:  'Wallis e Futuna',
  },
  {
    value: 'YE',
    text:  'Yémen',
  },
  {
    value: 'ZM',
    text:  'Zâmbia',
  },
  {
    value: 'ZW',
    text:  'Zimbabwe',
  },
];
export default nationalities;
